export const CollapsibleBlock = {
  Attachments: 'attachments',
  Comments: 'comments',
  Detail: 'detail',
  ExternalAttachments: 'ExternalAttachments',
};
